import { render, staticRenderFns } from "./certif-medical.html?vue&type=template&id=e6fb73e2&scoped=true&external"
import script from "./certif-medical.js?vue&type=script&lang=js&external"
export * from "./certif-medical.js?vue&type=script&lang=js&external"
import style0 from "./certif-medical.scss?vue&type=style&index=0&id=e6fb73e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fb73e2",
  null
  
)

export default component.exports